export const CLIENTES_VIEW = 'clientes/view'
